<template>
  <b-modal
    :id="id"
    :title="title"
    :ok-title="trans('save')"
    :ok-disabled="busy"
    :cancel-title="trans('cancel')"
    :size="size"
    no-enforce-focus
    @ok="onSave"
    @shown="onShown"
  >
    <b-form-group>
      <label v-html="label" class="d-block"></label>
      <html-textarea
        :organization="organization"
        v-model="description"
        :show-insert-form-document="showInsertFormDocument"
        :disabled="busy"
        :placeholders="placeholders"
      ></html-textarea>
    </b-form-group>
    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import HtmlTextarea from './HtmlTextarea'

  export default {
    props: {
      organization: Object,
      id: {
        type: String,
        default: 'html-textarea-modal',
      },
      size: {
        type: String,
        default: 'md',
      },
      title: {
        type: String,
        default: trans('description'),
      },
      data: Object, // to pass to back-end
      attr: {
        type: String,
        default: 'description'
      },
      label: {
        type: String,
        default: trans('description'),
      },
      value: [String, Boolean],
      url: String,
      showInsertFormDocument: {
        type: Boolean,
        default: false,
      },
      forMicrosite: {
        type: Boolean,
        default: false,
      },
      placeholders: Array|Object,
    },
    components: {
      HtmlTextarea,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        description: null,
      }
    },
    methods: {
      onShown() {
        this.busy = false
        this.error = null
        this.description = this.value
      },
      onSave(e) {
        if (!this.url) {
          this.$emit('input', this.description)
          return
        }
        e.preventDefault()
        this.busy = true
        this.error = null
        let data = this.data || {}
        data[this.attr] = this.description
        axios.patch(this.url, data)
        .then(response => {
          this.busy = false
          this.$emit('input', this.description)
          this.$emit('object', response.data)
          this.$bvModal.hide(this.id)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      }
    },
  }
</script>